import React, { useEffect, createElement } from 'react';
const CALENDLY_URL = 'https://calendly.com/yearone-calendar/exploration-call';
let scriptsLoaded = false;
let loadPromise: Promise<void> | null = null;
function loadCalendly(): Promise<void> {
  if (scriptsLoaded) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise(resolve => {
    // CSS
    if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
      const link = document.createElement('link');
      link.href = 'https://assets.calendly.com/assets/external/widget.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    // JS
    if (!document.querySelector('script[src*="calendly.com/assets/external/widget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => {
        scriptsLoaded = true;
        resolve();
      };
      document.body.appendChild(script);
    } else {
      scriptsLoaded = true;
      resolve();
    }
  });
  return loadPromise;
}
interface BookCallButtonProps {
  className?: string;
  children?: ReactNode;
}
export function BookCallButton({
  className = 'btn-primary whitespace-nowrap',
  children = 'Book a Free 1:1 Call'
}: BookCallButtonProps) {
  useEffect(() => {
    loadCalendly();
  }, []);
  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    await loadCalendly();
    const w = window as any;
    if (w.Calendly) {
      w.Calendly.initPopupWidget({
        url: CALENDLY_URL
      });
    }
  };
  return <button type="button" onClick={handleClick} className={className} data-id="element-39">
      {children}
    </button>;
}